<template>
  <div class="bs-special-background l-container">
    <!-- bs-special -->
    <div class="bs-special">
      <div class="bs-special-body">
        <!-- bs-preview -->
        <div class="bs-preview">
          <div class="mx-auto mx">
            <img
              src="@/assets/images/pages/01_010/header.png"
              class="image-preview block h-auto w-full"
            />
            <div class="text-preview">
              <h1>期間中に対象の商品を購入するとポイント5%アップ</h1>
            </div>
          </div>

          <div class="text-greeting">
            <div class="text-greeting-top">
              {{detailSpecEvent.spFeatureNm}}
            </div>
            <div class="text-greeting-bottom">
              <div class="text-greeting-bottom-appear">
                {{ 
                    detailSpecEvent.spFeatureDescription 
                  ?  detailSpecEvent.spFeatureDescription 
                  : '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪'
                }}
              </div>
            </div>
          </div>
        </div>
        <!-- bs-preview -->

        <!-- Cards-group -->
        <div class="cards-container">
          <div class="cards-group">
            <div class="flex flex-rows">
              <div class="grid grid-cols-3 gap-8 md:gap-8 sm:grid-cols-1 sm:gap-y-4" >
                <div class="card-item"  v-for="menu in menus" :key="menu.menuBasicInfo.menuNo" >
                  <div  class="w-full m-w-sm overflow-hidden group-hover:opacity-75 aspect-none sm:aspect-w-1 sm:aspect-h-1" >
                    <img
                      :src="menu.menuBasicInfo.menuImages[0].imageUrl"
                      :alt="menu.menuBasicInfo.menuImages[0].imageExplanation"
                      class="card-image"
                    />
                  </div>
                  <div class="card-detail mx-auto mt-3">
                    <div class="card-detail-fr1">
                      <div class="card-detail-fr1-left">
                        <div>
                          <Tag
                            text="旅"
                            :color="'#DA291C'"
                            :bgColor="'#F4F5F6'"
                          />
                         
                        </div>
                        <div class="frame-title">メニューNo.{{ menu.menuBasicInfo.menuNo }}</div>
                      </div>
                      <div class="card-detail-fr1-right">
                        <a href="#" @click="checkLogin">
                          <i class="icon icon-bor-heart-plus" />
                        </a>
                      </div>
                    </div>
                    <div class="card-detail-fr2">
                      <div class="des-title flex flex-wrap">
                        {{ menu.menuBasicInfo.menuNm }}
                      </div>
                      <div class="des-text flex flex-wrap">
                        {{ menu.menuBasicInfo.menuNmKana }}
                      </div>
                    </div>
                    <div class="rating" v-if="hiddenRating">
                      <Rating :rate="3" />
                    </div>
                    <div class="card-detail-fr3 table w-full">
                      <div class="table-row-group">
                        <div class="table-row">
                          <div class="cell-type table-cell">
                            エリア
                          </div>
                          <div class="cell-data table-cell">
                            北海道 > 温根湯
                          </div>
                        </div>
                        <div class="table-row">
                          <div class="cell-type table-cell">
                            アクセス
                          </div>
                          <div class="cell-data table-cell">
                            JR石北本線 留辺蘂駅 タクシー20分/道央自動車道 上川層…
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card-detail-fr4">
                      10,200 円〜
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <InstructionLogin1 :visible="showPopup"/>
        <!-- Cards-group -->
      </div>
    </div>
  </div>
</template>

<script>

import Tag from '@/components/primitive/Tag'
import _ from 'lodash'
import { GET_SPECIAL_EVENT_DETAIL } from '@/store/modules/spec/actions'

export default {
  name: 'BS_01-010',
  components: {
    Tag
  },
  data() {
    return {
      flag: 0,
      showPopup: false,
      hiddenRating: null,
      detailSpecEvent: {},
      menus: []
    }
  },
  mounted() {
    this.hiddenRating = this.viewRating()
    this.getSpecEventDetail()
  },
  computed: {
    getUserInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'auth', null))
    }
  },
  methods: {
    viewRating() {
      return !!this.$route.path.match('special-page')
    },
    getSpecEventDetail() {
      this.$store.dispatch(GET_SPECIAL_EVENT_DETAIL, this.$route.params.spFeatureId).then(
        (data) => {
          if(data !== null) {
            this.detailSpecEvent = data
            this.menus = data.menus
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
::v-deep .ant-tag{
  @apply mr-4;
  border-radius: 8px;
}
</style>
